<!--
  Sub-modale "Conferma cancellazione ordine" — pattern Diakonix native (v2.11.0 J.1).
  Backdrop fixed 100vw/100dvh + dialog centrato z-index 2000.
-->
@if (openConfirmCancel) {
  <div
    class="cc-backdrop"
    (click)="closeModal()"
  >
    <div
      class="cc-modal"
      role="dialog"
      aria-modal="true"
      aria-labelledby="cc-title"
      (click)="$event.stopPropagation()"
    >
      <header class="cc-header">
        <div class="cc-icon">
          <i class="bx bx-error-circle"></i>
        </div>
        <h2 id="cc-title">Conferma cancellazione</h2>
        <button
          type="button"
          class="cc-close"
          aria-label="Chiudi"
          (click)="closeModal()"
        >
          <i class="bx bx-x"></i>
        </button>
      </header>

      <form class="cc-body" [formGroup]="form" (ngSubmit)="confirmDelete()">
        <p class="cc-msg">
          Per procedere con la cancellazione dell'ordine
          @if (orderToGet?.or_order_number) {
            <strong>{{ orderToGet.or_order_number }}</strong>
          }
          inserisci la tua password.
        </p>

        <label class="cc-field">
          <span class="cc-field-label">Password</span>
          <div class="cc-input-wrap">
            <input
              [type]="showPassword ? 'text' : 'password'"
              formControlName="password"
              placeholder="La tua password"
              autocomplete="current-password"
              autofocus
            />
            <button
              type="button"
              class="cc-toggle-vis"
              [attr.aria-label]="showPassword ? 'Nascondi password' : 'Mostra password'"
              (click)="togglePasswordVisibility()"
            >
              <i class="bx" [class.bx-show]="!showPassword" [class.bx-hide]="showPassword"></i>
            </button>
          </div>
          @if (form.get('password')?.touched && form.get('password')?.invalid) {
            <small class="cc-error">Password obbligatoria.</small>
          }
        </label>

        <div class="cc-actions">
          <button
            type="submit"
            class="cc-btn cc-btn--confirm"
            [disabled]="submitting"
          >
            @if (submitting) {
              <i class="bx bx-loader-alt bx-spin"></i>
              Attendi...
            } @else {
              <i class="bx bx-check-circle"></i>
              Continua
            }
          </button>

          <button
            type="button"
            class="cc-btn cc-btn--cancel"
            (click)="closeModal()"
          >
            <i class="bx bx-x"></i>
            Annulla
          </button>
        </div>
      </form>
    </div>
  </div>
}
